const ZOOM = 4;
const pos = (c, s) => ((c - 0.5 / s) / (1 - 1 / s)) * 100;

export const LogoLoupe = ({ item }) => {
  const [cx, cy] = item.logo.map((v) => v / 100);
  const sy = ZOOM * item.ratio;
  return (
    <div
      data-testid={`coming-soon-loupe-${item.id}`}
      aria-hidden="true"
      className="pointer-events-none absolute right-4 top-4 h-16 w-16 scale-100 rounded-full shadow-[0_20px_40px_-10px_rgba(0,0,0,0.6)] ring-2 ring-white/90 transition-[opacity,transform] duration-500 ease-out md:h-32 md:w-32 md:scale-75 md:opacity-0 md:group-hover:scale-100 md:group-hover:opacity-100"
      style={{
        backgroundImage: `url(${item.img})`,
        backgroundSize: `${ZOOM * 100}% auto`,
        backgroundPosition: `${pos(cx, ZOOM)}% ${pos(cy, sy)}%`,
      }}
    >
      <span className="absolute -bottom-6 left-1/2 hidden -translate-x-1/2 whitespace-nowrap font-mono text-[10px] uppercase tracking-[0.2em] text-white md:block">Signature detail</span>
    </div>
  );
};
